"use strict";
/*
 * Created on 01 30 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var ModifiedCompetitorPriceDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ModifiedCompetitorPriceDTO, _DomainObject_1$Domai);

  /**
   * @param competitorPriceId
   * @param modifiedPrice competitorPrice modified by size charger and size ratio from binding with internal product
   */
  function ModifiedCompetitorPriceDTO(competitorPriceId, modifiedPrice) {
    var _this;

    _classCallCheck(this, ModifiedCompetitorPriceDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModifiedCompetitorPriceDTO).call(this));
    _this.competitorPriceId = competitorPriceId;
    _this.modifiedPrice = modifiedPrice;
    return _this;
  }

  return ModifiedCompetitorPriceDTO;
}(DomainObject_1.DomainObject);

exports.ModifiedCompetitorPriceDTO = ModifiedCompetitorPriceDTO;